// extracted by mini-css-extract-plugin
module.exports = {"login":"Login_login__2ggPt","control":"Login_control__2MmSv","invalid":"Login_invalid__1r4ik","actions":"Login_actions__CJ9B4"};